import axiosInstance from 'utils/axios';

/**
 * Fetch dynamic field values for a specific entity
 * @param {number} entityTypeCode - The entity type enum value (e.g. 3 for Vehicle)
 * @param {string} entityId - The unique ID (UUID) of the entity
 * @returns {Promise<Object>} Response object containing entity dynamic field values
 */
export const getEntityFieldValues = async (entityTypeCode, entityId) => {
  try {
    const response = await axiosInstance.get(`/api/EntityDynamicField/FieldValues/${entityTypeCode}/${entityId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching entity field values:', error);
    throw error;
  }
};

/**
 * Save dynamic field values for a specific entity
 * @param {Object} payload - The save request body
 * @param {number} payload.entityTypeCode - The entity type enum value
 * @param {string} payload.entityId - The unique ID (UUID) of the entity
 * @param {Array<{masterFieldId: string, fieldValue: string}>} payload.fields - The dynamic fields to save
 * @returns {Promise<Object>} Response object indicating success and updated values
 */
export const saveEntityFieldValues = async (payload, companyId = null, userId = null) => {
  try {
    const params = {};
    const compId = companyId || payload?.companyId || payload?.CompanyId;
    const usrId = userId || payload?.userId || payload?.UserId;
    if (compId) params.companyId = compId;
    if (usrId) params.userId = usrId;

    const response = await axiosInstance.post('/api/EntityDynamicField/SaveFieldValues', payload, { params });
    return response.data;
  } catch (error) {
    console.error('Error saving entity field values:', error);
    throw error;
  }
};
